import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';

export const fetchBulkPDF = async (query) => {
  const { data } = await apiClient.get(`/jobs`, { params: query.queryKey[1] });
  return data;
};
export const useGetBulkPDFHandler = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const [bulkPDFs, setbulkPDF] = useState([]);
  const [totalJobs, setTotalJobs] = useState(0);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['bulkPDF', { ...searchQuery }], // A unique key for this query
    queryFn: fetchBulkPDF,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    cacheTime: 0,
    retry: 3,
  });
  useEffect(() => {
    if (fetchedData) {
      setbulkPDF(fetchedData.jobs);
      setTotalJobs(fetchedData.totalJobs);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);
  return {
    bulkPDFs,
    totalJobs,
    isLoading,
  };
};
